import { Component, OnInit } from '@angular/core'

@Component({
    selector: 'CommonEnrollmentLayout',
    template: ` 
        <EnrollmentHeader [UserName]="UserName" [PlanYear]="planyear"></EnrollmentHeader>
        <router-outlet></router-outlet>
  `
})

export class CommonEnrollmentLayoutComponent implements OnInit {

    public UserName: string
    public planyear: number

    ngOnInit() {
     }

}
